<template>
  <div class="counter" :style="customStyle" v-if="dateInMilliseconds > now">
    <div class="counter__item">
      <p class="counter__value">{{ days | twoDigits }}</p>
      <p>{{ $t('home.days') }}</p>
    </div>
    <div class="counter__item">
      <p class="counter__value">{{ hours | twoDigits }}</p>
      <p>{{ $t('home.hours') }}</p>
    </div>
    <div class="counter__item">
      <p class="counter__value">{{ minutes | twoDigits }}</p>
      <p>{{ $t('home.minutes') }}</p>
    </div>
    <div class="counter__item">
      <p class="counter__value">{{ seconds | twoDigits }}</p>
      <p>{{ $t('home.seconds') }}</p>
    </div>
  </div>
</template>

<script>
  import { twoDigits } from "../helpers/filters";
  export default {
    name: "AppCounter",
    props: {
      date: {
        type: String,
        required: true,
      },
      eventColor: {
        type: String,
        default: ''
      }
    },
    filters: {
      twoDigits
    },
    data() {
      return {
        now: Math.trunc((new Date()).getTime() / 1000)
      }
    },
    computed: {
      customStyle() {
        return {
          '--event-color': this.eventColor
        }
      },
      dateInMilliseconds() {
        // Fix NAN problem in IE and Safari
        let dateStr = this.date.split('-').join('/');
        return Math.trunc(Date.parse(dateStr) / 1000)
      },
      seconds() {
        return (this.dateInMilliseconds - this.now) % 60;
      },
      minutes() {
        return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60;
      },
      hours() {
        return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
      },
      days() {
        return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
      }
    },
    mounted() {
      window.setInterval(() => this.now = Math.trunc((new Date()).getTime() / 1000) ,1000);
    },
  }
</script>

